import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-main-body',
  templateUrl: './main-body.component.html',
  styleUrls: ['./main-body.component.scss']
})
export class MainBodyComponent implements OnInit {

  @Input() language:any;
  constructor() { }

  ngOnInit() {
  }

}
